module.exports = __webpack_public_path__ + "img/Impact_ministries.db754dc3.png";